export const state = {
  dailytransactions: [],
  dailytransaction: [],
  
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/dailytransactions/state.js